/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData } from "../Request";
export default {
  state: {
    eventAndGroup: [],
  },
  getters: {
    GetEventAndGroup(state) {
      return state.eventAndGroup;
    },
  },
  actions: {
    async GetEventAndGroup({ commit }, payload) {
      return await Get(
        `EventAndGroup/GetEventAndGroup/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res) => {
        commit("SetEventAndGroup", res.data.Data.Data);
        return res.data.Data;
      });
    },
    async AddEventAndGroup({ commit }, payload) {
      return await Post(`EventAndGroup/AddEventAndGroup`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async EditEventAndGroup({ commit }, payload) {
      return await Post(`EventAndGroup/EditEventAndGroup`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async DeleteEventAndGroup({ commit }, payload) {
      return await Delete(`EventAndGroup/DeleteEventAndGroup/${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
  },
  mutations: {
    SetEventAndGroup(state, payload) {
      state.eventAndGroup = payload;
    },
  },
};
